<template>
  <div :class="{ 'mb-4 rounded-sm border border-primary bg-surface-elevation-1 p-6': fenced }">
    <FencingHeaderCTA
      v-if="fenced"
      :label="label"
      :help-link="helpLink"
      :help-tooltip="helpTooltip"
      :upgrade-cta="upgradeCta"
      :upgrade-cta-link="upgradeCtaLink"
      :placement="placement"
      :entity-type="entityType"
      :entity-id="entityId"
    />
    <slot />
  </div>
</template>
<script setup lang="ts">
import { type EntityType } from '@ramp106/omrjs-tracking-reviews'

import FencingHeaderCTA from '@/components/ReviewsCommon/Fencing/FencingHeaderCTA.vue'

withDefaults(
  defineProps<{
    fenced?: boolean
    label: string
    helpLink?: string
    helpTooltip?: string
    upgradeCta: string
    upgradeCtaLink: string
    placement: string
    entityType: EntityType
    entityId: string
  }>(),
  {
    fenced: false,
    helpLink: undefined,
    helpTooltip: undefined,
  },
)
</script>
